export default __webpack_public_path__ + "ceb812262875e6579d5e67842b8ea8f2.png";